var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.loading)?[_c('alert-loading')]:(_vm.error)?[_c('alert-error')]:(!_vm.error && !_vm.alertData)?[_c('alert-no-records')]:[_c('alert-view',{attrs:{"items":_vm.filterAlertList,"columnHeaders":_vm.alertData.cols}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }